// extracted by css-extract-rspack-plugin
export default {"cls1":"RecommendedPodcasts-cls1_5T9","cls2":"RecommendedPodcasts-cls2_hzq RecommendedPodcasts-cls1_5T9"};